import lang from "@/views/modules/BudgetHeads/language/en";

let searchFieldsDef = {
    'name': {
        label: lang.LBL_BUDGETHEAD_NAME,
    },
    'head_sequence': {
        label: lang.LBL_BUDGETHEAD_SEQUENCE,
    },
};
export default { searchFieldsDef }